import React from 'react';
import { connect } from 'react-redux';
import { branch, compose, renderNothing, withHandlers, withState, lifecycle } from 'recompose';
import { SubTitle as ItemSubTitle } from '../../../../../../components/list';
import { parseMessage } from '../../../../../question/helpers/parse-message';

const SubTitleComponent = React.memo(({ itemSubTitle }) => <ItemSubTitle>{itemSubTitle}</ItemSubTitle>);

const mapStateToProps = ({ userAttributes }) => ({ userAttributes });

export const SubTitle = compose(
  branch(({ subTitle }) => !subTitle, renderNothing),
  connect(mapStateToProps),
  withState('itemSubTitle', 'setItemSubTitle', ''),
  withHandlers({
    setItemSubTitleHandler:
      ({ subTitle, userAttributes, setItemSubTitle }) =>
      async () => {
        const subTitleParsed = await parseMessage(userAttributes, subTitle);

        setItemSubTitle(subTitleParsed);
      }
  }),
  lifecycle({
    componentDidMount() {
      const { setItemSubTitleHandler } = this.props;

      setItemSubTitleHandler();
    },
    componentDidUpdate(prevProps) {
      const { setItemSubTitleHandler, userAttributes } = this.props;

      if (prevProps.userAttributes !== userAttributes) {
        setItemSubTitleHandler();
      }
    }
  })
)(SubTitleComponent);
